import React, { useCallback, useEffect, useState } from 'react';

import { IEvent } from '@/@types/events';
import EventBox from '@/components/EventBox';
import Layout from '@/components/Layout';
import { api } from '@/services/api';
import { Container, TitleHidden } from '@/styles';
import { makeCdnLink } from '@/utils';

import * as S from './styles';

export type TemplateListEventsProps = {
  limit?: number;
  events: IEvent[];
};

const TemplateListEvents = ({
  limit = 12,
  events,
}: TemplateListEventsProps) => {
  const [page, setPage] = useState(2);
  const [loading, setLoading] = useState(false);
  const [haveNextPage, setHaveNextPage] = useState(true);
  const [stateEvents, setEvents] = useState<IEvent[]>([]);

  const handleLoadMore = useCallback(async () => {
    try {
      setLoading(true);

      const response = await api.get('/v1/web/events', {
        params: { page, limit },
      });

      if (response.data.events?.length > 0) {
        setPage(oldPage => oldPage + 1);
        setEvents(oldEvents => [...oldEvents, ...response.data.events]);
      } else {
        setHaveNextPage(false);
      }
    } finally {
      setLoading(false);
    }
  }, [page, limit]);

  useEffect(() => {
    setEvents(events);
  }, [events]);

  return (
    <Layout>
      <Container>
        <S.Wrapper>
          <S.SearchBox />

          <S.EventsWrapper>
            <TitleHidden>Eventos</TitleHidden>

            <S.EventsList>
              {stateEvents.map(row => (
                <EventBox
                  key={`event-id-${row.codEvento}`}
                  title={row.nomeEvento}
                  createdAt={row.dataIniEvento}
                  imageUrl={makeCdnLink(row.imagemEvento)}
                  location={row.localEvento}
                  redirectTo={`/evento/${row.codEvento}/${row.slugEvento}`}
                />
              ))}
            </S.EventsList>
          </S.EventsWrapper>

          {haveNextPage && (
            <S.LoadMoreWrapper>
              <S.LoadMoreButton onClick={handleLoadMore} disabled={loading}>
                {loading ? 'Aguarde...' : 'Carregar mais'}
              </S.LoadMoreButton>
            </S.LoadMoreWrapper>
          )}
        </S.Wrapper>
      </Container>
    </Layout>
  );
};

export default React.memo(TemplateListEvents);
